var map = {
	"./de.json": 91229,
	"./default.json": 96963,
	"./en.json": 27473,
	"./es.json": 56018,
	"./fr.json": 47946,
	"./hr.json": 35144,
	"./it.json": 78355,
	"./ru.json": 44787
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 46761;